/*
 * Size-conflict notice (ürün sayfası)
 * Bu ürün (herhangi bir beden) zaten sepetteyse, beden seçeneklerinin altındaki
 * uyarı kutusunu gösterir — müşteri aynı üründen ikinci bir adet eklemek üzere
 * olduğunda uyarmak için. Hem 2. FARKLI beden (ör. M + L) hem AYNI bedenden
 * 2. adet (ör. L + L) bu durumu tetikler.
 * Veri: snippets/size-conflict-notice.liquid içindeki config script'i.
 * Tetikleyici: PUB_SUB_EVENTS.cartUpdate (sepet değişimi) + ilk yükleme.
 */
(function () {
  function readConfig() {
    const el = document.querySelector('[data-size-conflict-config]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function init() {
    const config = readConfig();
    if (!config || !config.productId) return;
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    function check() {
      const box = document.getElementById(config.noticeId);
      if (!box) return;

      fetch(`${window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/'}cart.js`, {
        headers: { Accept: 'application/json' },
      })
        .then((res) => res.json())
        .then((cart) => {
          const productInCart = (cart.items || []).some(
            (item) => item.product_id === config.productId
          );

          // Bu ürün sepette varken hâlâ onun sayfasındaysak, ikinci bir adet
          // (aynı ya da farklı beden) ekleme riski var → uyarıyı göster.
          if (productInCart) {
            box.classList.remove('hidden');
          } else {
            box.classList.add('hidden');
          }
        })
        .catch(() => {});
    }

    // Sepet değiştiğinde (ör. bu sayfadan sepete eklendiğinde) tekrar kontrol et.
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      setTimeout(check, 0);
    });

    // İlk yüklemede de kontrol et (ürün sepette zaten olabilir).
    check();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
